import { Prize, PrizeType } from './types';
import { getStaticAsset } from '@/utils/staticAsset';

const one = {
  rewardType: PrizeType.One,
  text: 'Stone 1',
  img: getStaticAsset('/assets/images/casino/rush-game/symbols/1.png'),
  openImg: getStaticAsset('/assets/images/casino/rush-game/symbols/1-open.png'),
  probability: '0.001%',
  multiplier: 100,
};
const two = {
  rewardType: PrizeType.Two,
  text: 'Stone 2',
  img: getStaticAsset('/assets/images/casino/rush-game/symbols/2.png'),
  openImg: getStaticAsset('/assets/images/casino/rush-game/symbols/2-open.png'),
  probability: '0.002%',
  multiplier: 50,
};
const three = {
  rewardType: PrizeType.Three,
  text: 'Stone 3',
  img: getStaticAsset('/assets/images/casino/rush-game/symbols/3.png'),
  openImg: getStaticAsset('/assets/images/casino/rush-game/symbols/3-open.png'),
  probability: '0.012%',
  multiplier: 30,
};
const four = {
  rewardType: PrizeType.Four,
  text: 'Stone 4',
  img: getStaticAsset('/assets/images/casino/rush-game/symbols/4.png'),
  probability: '0.042%',
  multiplier: 25,
};
const five = {
  rewardType: PrizeType.Five,
  text: 'Stone 5',
  img: getStaticAsset('/assets/images/casino/rush-game/symbols/5.png'),
  probability: '0.077%',
  multiplier: 20,
};
const six = {
  rewardType: PrizeType.Six,
  text: 'Stone 6',
  img: getStaticAsset('/assets/images/casino/rush-game/symbols/6.png'),
  probability: '0.117%',
  multiplier: 15,
};
const seven = {
  rewardType: PrizeType.Seven,
  color: '#E7AB7E',
  text: 'Stone 7',
  img: getStaticAsset('/assets/images/casino/rush-game/symbols/7.png'),
  probability: '0.162%',
  multiplier: 5,
};
const eight = {
  rewardType: PrizeType.Eight,
  color: '#81BDD1',
  text: 'Stone 8',
  img: getStaticAsset('/assets/images/casino/rush-game/symbols/8.png'),
  probability: '31.002%',
  multiplier: 2,
};
const nine = {
  rewardType: PrizeType.Nine,
  color: '#FDCB35',
  text: 'Stone 9',
  img: getStaticAsset('/assets/images/casino/rush-game/symbols/9.png'),
  probability: '68.585%',
  multiplier: 0.1,
};
export const PRIZEMaps: Record<PrizeType, Prize> = {
  [PrizeType.Nine]: nine,
  [PrizeType.Eight]: eight,
  [PrizeType.Seven]: seven,
  [PrizeType.One]: one,
  [PrizeType.Two]: two,
  [PrizeType.Three]: three,
  [PrizeType.Four]: four,
  [PrizeType.Five]: five,
  [PrizeType.Six]: six,
};

export const WHEEL_ALL_PRIZE_LIST: Prize[] = [
  nine,
  five,
  two,
  eight,
  nine,
  eight,
  seven,
  four,
  six,
  seven,
  four,
  three,
  six,
  eight,
  five,
  three,
  nine,
  one,
];

export const IsMoneyAward = (type) => {
  return true;
  // return [PrizeType.Nine, PrizeType.Eight, PrizeType.Seven].includes(type);
};

export const IsTimeAward = (type) => {
  return false;
  // return [
  //   PrizeType.One,
  //   PrizeType.Two,
  //   PrizeType.Three,
  //   PrizeType.Four,
  //   PrizeType.Five,
  // ].includes(type);
};
